var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container padd-top-80",attrs:{"id":"teachers"}},[_vm._m(0),_c('div',{staticClass:"row"},_vm._l((_vm.mentors),function(mentor){return _c('mentor-card',{key:mentor.name,attrs:{"mentor":mentor}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tv-heading-title text-center"},[_c('h2',[_vm._v(" 导师 "),_c('span',[_vm._v("成员")])])])
}]

export { render, staticRenderFns }